// Resolves a webcam `videoStream` URL to the HLS playlist we should play
// ourselves, or null when the URL is a provider player that must stay an
// iframe (Feratel, YouTube, ...).
//
// The API hands HLS cams over in two shapes:
//   - the raw playlist:  https://stream.profi-net.sk/tmr/STREAM21.stream/playlist.m3u8
//   - wrapped in roob's player page, playlist in `param`:
//       https://player.roob.sk/?param=https://stream.profi-net.sk/tmr/STREAM17.stream/playlist.m3u8
//
// Neither works as an iframe. A raw playlist renders as the browser's bare
// media document (no autoplay, nothing at all in browsers without native
// HLS), and roob's page runs video.js 6 + videojs-contrib-hls, which defers
// to the browser's native HLS whenever canPlayType says 'maybe'. Current
// desktop Chrome does, and its native pipeline intermittently fails these
// Wowza playlists with DEMUXER_ERROR_COULD_NOT_PARSE, which video.js shows as
// "The media could not be loaded...". Unwrapping to the playlist and driving
// it through hls.js (MSE) avoids both.

const HLS_WRAPPER_HOSTS = new Set(['player.roob.sk', 'playerold.roob.sk']);
const HLS_WRAPPER_PARAM = 'param';

const parseHttpUrl = (value: string): URL | null => {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url : null;
  } catch {
    return null;
  }
};

const isHlsPlaylist = (url: URL) => url.pathname.toLowerCase().endsWith('.m3u8');

export const getHlsSource = (videoStream: string): string | null => {
  const url = parseHttpUrl(videoStream.trim());
  if (!url) return null;

  if (HLS_WRAPPER_HOSTS.has(url.hostname)) {
    const inner = parseHttpUrl(url.searchParams.get(HLS_WRAPPER_PARAM) ?? '');
    return inner && isHlsPlaylist(inner) ? inner.href : null;
  }

  return isHlsPlaylist(url) ? url.href : null;
};
